import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";
import { api, errMsg } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { ConfirmDialog } from "./ConfirmDialog";

const KINDS = ["Godown", "Showroom", "Other"];

export const LocationsTab = () => {
  const { isAdmin, can } = useAuth();
  const [list, setList] = useState([]);
  const [name, setName] = useState("");
  const [kind, setKind] = useState("Godown");
  const [deleting, setDeleting] = useState(null);
  const load = useCallback(() => {
    api.get("/locations").then((r) => setList(r.data));
  }, []);
  useEffect(() => {
    load();
  }, [load]);

  const add = async (e) => {
    e.preventDefault();
    try {
      await api.post("/locations", { name, kind });
      setName("");
      toast.success("Location added");
      load();
    } catch (err) {
      toast.error(errMsg(err));
    }
  };
  const changeKind = async (l, k) => {
    try {
      await api.put(`/locations/${l.id}`, { name: l.name, kind: k });
      load();
    } catch (err) {
      toast.error(errMsg(err));
    }
  };
  const remove = async () => {
    try {
      await api.delete(`/locations/${deleting.id}`);
      load();
    } catch (err) {
      toast.error(errMsg(err));
    }
    setDeleting(null);
  };

  return (
    <div className="space-y-3" data-testid="locations-tab">
      {can("location_write") && <form onSubmit={add} className="panel space-y-3 p-4">
        <h3 className="font-heading font-bold">Godowns &amp; showrooms</h3>
        <input className="field" required placeholder="e.g. Jayanagar Showroom" value={name} onChange={(e) => setName(e.target.value)} data-testid="location-name-input" />
        <div className="grid grid-cols-2 gap-2">
          <select className="field" value={kind} onChange={(e) => setKind(e.target.value)} data-testid="location-kind-select">
            {KINDS.map((k) => <option key={k}>{k}</option>)}
          </select>
          <button className="btn btn-primary" data-testid="add-location-btn"><Plus size={18} /> Add</button>
        </div>
      </form>}
      {list.map((l) => (
        <div key={l.id} className="panel flex items-center gap-3 p-3" data-testid={`location-row-${l.name}`}>
          <span className="min-w-0 flex-1 truncate font-semibold">{l.name}</span>
          <select className="field !w-32 shrink-0" value={l.kind} onChange={(e) => changeKind(l, e.target.value)} data-testid={`location-kind-${l.name}`}>
            {KINDS.map((k) => <option key={k}>{k}</option>)}
          </select>
          {isAdmin && <button className="icon-btn hover:!text-destructive" onClick={() => setDeleting(l)} aria-label="Delete location" data-testid={`location-delete-${l.name}`}><Trash2 size={18} /></button>}
        </div>
      ))}
      <ConfirmDialog open={!!deleting} onCancel={() => setDeleting(null)} onConfirm={remove} title={`Delete ${deleting?.name}?`} body="Past receipts keep the location name." />
    </div>
  );
};
